import React from 'react';
import { Mail, Sparkles, Filter, PenSquare, Send, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { NodeData } from './types';
const IconMap: Record<string, React.ElementType> = {
  Mail,
  Sparkles,
  Filter,
  PenSquare,
  Send
};
interface NodeCardProps {
  node: NodeData;
  isSelected: boolean;
  onClick: () => void;
}
export function NodeCard({
  node,
  isSelected,
  onClick
}: NodeCardProps) {
  const Icon = IconMap[node.icon];
  return <motion.div className={`absolute w-[220px] rounded-xl bg-slate-900/90 backdrop-blur-sm border cursor-pointer transition-all duration-200 z-10 ${isSelected ? 'border-sky-400 glow-sky shadow-lg shadow-sky-900/20' : 'border-slate-700 hover:border-slate-500 shadow-xl shadow-black/40'}`} style={{
    left: node.x,
    top: node.y
  }} onClick={onClick} whileHover={{
    y: -2
  }} layoutId={`node-${node.id}`} data-id="element-67">
      <div className="p-3.5 flex flex-col gap-3" data-id="element-68">
        {/* Header */}
        <div className="flex items-start justify-between" data-id="element-69">
          <div className="flex items-center gap-3" data-id="element-70">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${node.color}`} data-id="element-71">
              <Icon className="w-5 h-5" data-id="element-72" />
            </div>
            <div data-id="element-73">
              <h3 className="text-sm font-semibold text-slate-100 leading-tight" data-id="element-74">
                {node.title}
              </h3>
              <span className="text-[11px] font-medium text-slate-400 uppercase tracking-wider" data-id="element-75">
                {node.label}
              </span>
            </div>
          </div>
        </div>

        {/* Footer / Status */}
        <div className="flex items-center justify-between pt-2 border-t border-slate-800/60" data-id="element-76">
          <div className="flex items-center gap-1.5" data-id="element-77">
            {node.status === 'ok' && <>
                <div className="w-2 h-2 rounded-full bg-emerald-500 glow-emerald" data-id="element-78" />
                <span className="text-xs text-slate-400" data-id="element-79">Ready</span>
              </>}
            {node.status === 'loading' && <>
                <div className="w-2 h-2 rounded-full bg-sky-500 animate-pulse glow-sky" data-id="element-80" />
                <span className="text-xs text-sky-400" data-id="element-81">Processing...</span>
              </>}
          </div>
          {isSelected && <div className="w-1.5 h-1.5 rounded-full bg-sky-400" data-id="element-82" />}
        </div>
      </div>
    </motion.div>;
}